import { BranchBankAccountMappingPage } from "@/features/branch-bank-account/pages/BranchBankAccountMappingPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/branch-bank-account/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["branch_bank_account.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: BranchBankAccountMappingPage,
});
